"use client";

import { backendClient } from "@/lib/backend-api";
import { useQuery } from "@tanstack/react-query";

export function SubdomainProvisioner({
  shopId,
  pendingSubdomain,
}: {
  shopId: number;

  pendingSubdomain: string | null;
}) {
  useQuery({
    queryKey: ["subdomain", shopId],
    queryFn: () => backendClient.subdomain.status(),
    enabled: !!pendingSubdomain,
    refetchOnWindowFocus: false,
    refetchInterval: (query) => {
      const status = query.state.data;
      if (!status) return false;
      return status.verified && !status.misconfigured ? false : 30_000;
    },
  });

  return null;
}
